var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSomethingCoolAdaptiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 151,
    viewBox: "0 0 152 151",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1469 93.2964C73.8723 94.0785 73.4056 94.8607 72.7468 95.6429C72.0879 96.3729 71.3192 97.0507 70.4407 97.6765C69.6171 98.2501 68.7386 98.7194 67.8052 99.0844C66.8718 99.4494 66.0208 99.6319 65.2521 99.6319H27.1198C26.3511 99.6319 25.6373 99.4494 24.9784 99.0844C24.3196 98.7194 23.7705 98.2501 23.3313 97.6765C22.9469 97.0507 22.6998 96.3729 22.59 95.6429C22.4802 94.8607 22.5626 94.0785 22.8371 93.2964L27.3669 80.7817H39.2266L36.1793 89.0727H63.7696L66.8169 80.7817H78.6766L74.1469 93.2964ZM84.03 65.2949C83.9751 65.5556 83.9476 65.7903 83.9476 65.9989C83.9476 66.2074 83.8927 66.416 83.7829 66.6246L82.8769 68.9711H31.5672L32.4731 66.6246C32.5829 66.416 32.6653 66.2074 32.7202 65.9989C32.83 65.7903 32.9673 65.5556 33.132 65.2949H84.03ZM79.5002 60.2891C80.4885 60.2891 81.367 60.5759 82.1357 61.1494C82.9044 61.723 83.4534 62.453 83.7829 63.3395H34.7792C35.7675 62.453 36.8656 61.723 38.0736 61.1494C39.2815 60.5759 40.3796 60.2891 41.3679 60.2891H79.5002ZM70.4407 70.8483H42.8504L41.4503 74.6027H29.5906L31.073 70.4572H82.3828L80.9003 74.6027H69.0406L70.4407 70.8483ZM27.5316 80.2342L29.1788 75.6195H41.1208L39.3913 80.2342H27.5316ZM66.9816 80.2342L68.7112 75.6195H80.4885L78.8413 80.2342H66.9816Z",
    fill: "#FF86EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.688 93.2964C130.414 94.0785 129.947 94.8607 129.288 95.6429C128.629 96.3729 127.861 97.0507 126.982 97.6765C126.159 98.2501 125.28 98.7194 124.347 99.0844C123.413 99.4494 122.562 99.6319 121.794 99.6319H83.6613C82.8926 99.6319 82.1788 99.4494 81.5199 99.0844C80.8611 98.7194 80.312 98.2501 79.8728 97.6765C79.4884 97.0507 79.2413 96.3729 79.1315 95.6429C79.0217 94.8607 79.1041 94.0785 79.3786 93.2964L83.9084 80.7817H95.7681L92.7208 89.0727H120.311L123.358 80.7817H135.218L130.688 93.2964ZM140.571 65.2949C140.517 65.5556 140.489 65.7903 140.489 65.9989C140.489 66.2074 140.434 66.416 140.324 66.6246L139.418 68.9711H88.1087L89.0146 66.6246C89.1244 66.416 89.2068 66.2074 89.2617 65.9989C89.3715 65.7903 89.5088 65.5556 89.6735 65.2949H140.571ZM136.042 60.2891C137.03 60.2891 137.909 60.5759 138.677 61.1494C139.446 61.723 139.995 62.453 140.324 63.3395H91.3207C92.309 62.453 93.4071 61.723 94.615 61.1494C95.823 60.5759 96.9211 60.2891 97.9094 60.2891H136.042ZM126.982 70.8483H99.3919L97.9918 74.6027H86.132L87.6145 70.4572H138.924L137.442 74.6027H125.582L126.982 70.8483ZM84.0731 80.2342L85.7203 75.6195H97.6623L95.9328 80.2342H84.0731ZM123.523 80.2342L125.253 75.6195H137.03L135.383 80.2342H123.523Z",
    fill: "#FF86EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1065 46.2422H115.28L113.161 51.8626H89.9883L92.1065 46.2422Z",
    fill: "#FF86EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8994 46.2422H59.0731L56.9543 51.8626H33.7812L35.8994 46.2422Z",
    fill: "#FF86EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.703 60.9621H140.405V65.2892H144.703V60.9621Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.002 65.29L144.703 65.2892L144.704 69.6172H149.002V65.29Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.002 69.6172H144.704V73.9451H149.002V69.6172Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.704 69.6172L140.405 69.618V73.9451H144.704V69.6172Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.703 73.8953H140.405V78.2224H144.703V73.8953Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.405 78.2224L136.107 78.2232V82.5504H140.404L140.405 78.2224Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.405 69.618H136.107V73.9451H140.405V69.618Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.405 73.8953H136.107V78.2232L140.405 78.2224V73.8953Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M136.107 78.2232H131.81V82.5504H136.107V78.2232Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M136.107 82.5504H131.81V86.8761H136.108L136.107 82.5504Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M131.81 82.5504L127.514 82.549V86.8761H131.81V82.5504Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.514 82.549H123.215V86.8761H127.514V82.549Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M131.81 86.8761H127.514V91.204H131.812L131.81 86.8761Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9384 86.8769H71.6406V91.204H75.9384V86.8769Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M127.511 86.8769H123.213V91.204H127.511V86.8769Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6406 86.8769H67.3442V91.204H71.6406V86.8769Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3433 82.549H63.0455V86.8761L67.3442 86.8769L67.3433 82.549Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3433 78.2232H63.0455V82.549H67.3433V78.2232Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3433 73.8953H63.0455V78.2232H67.3433V73.8953Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6398 73.8953H67.3433V78.2232L71.6398 78.2224V73.8953Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M123.213 86.8769H118.917V91.204H123.213V86.8769Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3442 86.8769L63.0455 86.8761V91.204H67.3442V86.8769Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0455 82.549H58.7491V86.8761H63.0455V82.549Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0455 78.2232H58.7491V82.549H63.0455V78.2232Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0455 73.8953H58.7491V78.2232H63.0455V73.8953Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M123.215 82.549H118.917V86.8769H123.213L123.215 82.549Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M123.214 78.2695H118.917V82.5966H123.214V78.2695Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M123.214 73.9438H118.917V78.2695H123.214V73.9438Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.511 73.9438H123.214V78.2695L127.511 78.2709V73.9438Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.619 73.9438H110.321V78.2709H114.619V73.9438Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M114.619 78.2232H110.321V82.5504H114.619V78.2232Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M114.619 82.5504H110.321V86.8761H114.619V82.5504Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M118.917 86.8769L114.619 86.8761L114.62 91.204H118.917V86.8769Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0455 86.8761H58.7491V91.204H63.0455V86.8761Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7491 82.549H54.4505V86.8761H58.7491V82.549Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7491 78.2232H54.4505V82.549H58.7491V78.2232Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4505 78.2232H50.1519V82.5504L54.4505 82.549V78.2232Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7491 73.8953H54.4505V78.2232H58.7491V73.8953Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4505 73.8953H50.1519V78.2232H54.4505V73.8953Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1519 73.8953H45.8555V78.2224L50.1519 78.2232V73.8953Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M118.917 82.549L114.619 82.5504V86.8761L118.917 86.8769V82.549Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M118.917 78.2695L114.619 78.2709L114.62 82.5966H118.917V78.2695Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M118.917 73.9438H114.619V78.2709L118.917 78.2695V73.9438Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M110.321 73.9438H106.023V78.2709H110.321V73.9438Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M88.832 73.9438H84.5342V78.2709H88.832V73.9438Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5356 78.2232H80.2378V82.5504H84.5356V78.2232Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2378 82.5504L75.9392 82.549L75.9384 86.8769L80.237 86.8761L80.2378 82.5504Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M106.023 73.9438H101.724V78.2709H106.023V73.9438Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5342 73.9438H80.2378V78.2709H84.5342V73.9438Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2378 78.2232H75.9392V82.549L80.2378 82.5504V78.2232Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9384 73.9438H71.6406V78.2709H75.9384V73.9438Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M71.642 82.549H67.3433L67.3442 86.8769H71.6406L71.642 82.549Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9392 82.549H71.642L71.6406 86.8769H75.9384L75.9392 82.549Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M110.321 78.2232H106.023V82.5504H110.321V78.2232Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M131.812 73.9438H127.514V78.2709H131.812V73.9438Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M136.107 69.618H131.81L131.812 73.9438L136.107 73.9451V69.618Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M131.81 69.618H127.514V73.9438H131.812L131.81 69.618Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M127.511 69.618H123.213L123.214 73.9438H127.511V69.618Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M123.213 69.618H118.917V73.9438H123.214L123.213 69.618Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M118.917 69.618H114.62L114.619 73.9438H118.917V69.618Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M114.62 69.618H110.321V73.9438H114.619L114.62 69.618Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M110.321 69.618H106.023V73.9438H110.321V69.618Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M106.023 69.618H101.724V73.9438H106.023V69.618Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M101.724 69.618H97.4278V73.9451L101.724 73.9438V69.618Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4278 69.618H93.1314V73.9451H97.4278V69.618Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1284 69.618H88.8306L88.832 73.9438L93.1284 73.9451V69.618Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8306 69.618H84.5342V73.9438H88.832L88.8306 69.618Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5342 69.618H80.2378V73.9438H84.5342V69.618Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2378 69.618H75.9392L75.9384 73.9438H80.2378V69.618Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9392 69.618H71.6406V73.9438H75.9384L75.9392 69.618Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6406 69.618H67.3442V73.9451L71.6406 73.9438V69.618Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3442 69.618H63.0455V73.9451H67.3442V69.618Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0455 69.618H58.7491V73.9451H63.0455V69.618Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7491 69.618H54.4505V73.9451H58.7491V69.618Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4505 69.618H50.1519V73.9451H54.4505V69.618Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1519 69.618H45.8555V73.9451H50.1519V69.618Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8555 69.618H41.5569V73.9451H45.8555V69.618Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5561 65.29H37.2583V69.6172L41.5569 69.618L41.5561 65.29Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2596 60.9621H32.9618V65.2892L37.2583 65.29L37.2596 60.9621Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M32.961 56.6342H28.6632V60.9613L32.9618 60.9621L32.961 56.6342Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M140.404 56.6342H136.107V60.9613L140.405 60.9621L140.404 56.6342Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6624 52.3062H24.3646V56.6334L28.6632 56.6342L28.6624 52.3062Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M136.106 52.3062H131.808V56.6334L136.107 56.6342L136.106 52.3062Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3638 47.9783H20.066V52.3054L24.3646 52.3062L24.3638 47.9783Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M131.807 47.9783H127.509V52.3054L131.808 52.3062L131.807 47.9783Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0652 43.6504H15.7674V47.9775L20.066 47.9783L20.0652 43.6504Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M127.509 43.6504H123.211V47.9775L127.509 47.9783L127.509 43.6504Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7663 39.3249H11.4685V43.6521L15.7674 43.6504L15.7663 39.3249Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M123.209 39.324H118.911V43.6511L123.211 43.6504L123.209 39.324Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4685 39.3249L7.16982 39.3238V43.651L11.4685 43.6521V39.3249Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16982 39.3238H2.87109V43.651H7.16982V39.3238Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M118.911 35H114.613V39.3271H118.911V35Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M114.613 35H110.314V39.3271H114.613V35Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M110.314 35H106.016V39.3271H110.314V35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingCoolAdaptiveIcon);
export default __webpack_public_path__ + "static/media/SomethingCoolAdaptiveIcon.7e5a3d376c7035c09261ca8b1ab1be4d.svg";
export { ForwardRef as ReactComponent };